import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const TrainingVideoCreateForm = React.lazy(() => loadComponent('traiwiss', 'TrainingVideoCreateForm'))

export function TrainingVideoCreateFormRoute() {
    const navigate = useNavigate()
    const { academy } = useFlightDeck()

    const onCreate = useCallback(() => {
        navigate('/training-videos/')
    }, [navigate])

    const onClose = useCallback(() => {
        navigate('/training-videos')
    }, [navigate])

    return (
        <RouteContainer>
            <TrainingVideoCreateForm academyId={academy?._id} onCreated={onCreate} onClosed={onClose} />
        </RouteContainer>
    )
}
